import useSetNumVisibleOnResize from './useSetNumVisibleOnResize'

export default useSetNumVisibleOnResize
